import { TOOLS, ToolId } from '../data/tools';

interface ToolLogoProps {
  toolId: ToolId;
  size?: 40 | 48 | 56;
  showLabel?: boolean;
}

/**
 * A single tool/technology chip: white circular logo (or monogram fallback) + label.
 * Hovering/focusing the logo shows the tool name as a tag (data-tip), so the
 * name is always discoverable even in compact mode where labels are hidden.
 */
function ToolLogo({ toolId, size = 48, showLabel = true }: ToolLogoProps) {
  const tool = TOOLS[toolId];
  if (!tool) return null;

  return (
    <div className="tool-chip">
      <div
        className="tool-chip-logo"
        style={{ width: size, height: size }}
        data-tip={tool.name}
        tabIndex={0}
        aria-label={tool.name}
      >
        {tool.logo ? (
          <img src={tool.logo} alt="" width={size * 0.6} height={size * 0.6} />
        ) : (
          <span className="tool-chip-mono">{tool.monogram}</span>
        )}
      </div>
      {showLabel && <span className="tool-chip-label">{tool.name}</span>}
    </div>
  );
}

export default ToolLogo;
